// A general list of country codes.

export enum CountryCode {
  DE = "DE",
  CH = "CH",
  ES = "ES",
  GB = "GB",
  CZ = "CZ",
  ZA = "ZA",
  AE = "AE",
  MY = "MY",
  AT = "AT",
  FR = "FR",
  NO = "NO",
  SK = "SK",
  RO = "RO",
  HU = "HU",
}
